<script setup>
import {init} from '@communigator/sso-product-widget'
import {onMounted, ref} from 'vue'
import {PlatformServicesEnvironmentProvider} from '@/shared/PlatformServicesEnvironmentProvider'
import useUser from '@/shared/useUser'
import useTenant from '@/shared/useTenant'

defineProps({
    menuCollapsed: {
        type: Boolean,
        default: false
    }
})

const widget = ref(undefined)
const open = ref(false)

onMounted(() => {
    const widgetSettings = {
        targetEl: '#single-sign-on-widget',
        i18n: {
            locale: 'en',
        },
        integratorProductId: 'spotler-crm',
        integratorEnvironmentId: useTenant().value.uuid,
        platformServicesEnvironmentProvider: new PlatformServicesEnvironmentProvider(useUser().value.spotler_sso_id),
        eventHandlers: {
            onOpen: () => open.value = true,
            onClose: () => open.value = false,
        }
    }

    widget.value = init(widgetSettings)
})

function toggleWidget() {
    if (!open.value) {
        return widget.value.commands.open(15, 15)
    }

    return widget.value.commands.close()
}
</script>

<template>
    <button
        type="button"
        class="relative z-50"
        :class="{
            'order-2 mt-3': menuCollapsed,
            'top-px': !menuCollapsed
        }"
        @click="toggleWidget"
    >
        <i class="text-2xl text-white fa-solid fa-grid" />
    </button>
    <div
        id="single-sign-on-widget"
        class="z-50 product-widget"
    />
</template>

<style>
#single-sign-on-widget #sp-product-widget {
    top: 0;
    left: 0;
}
</style>